// EXEMPT
import { readState } from "@/__main__/app-state.mjs";
import blitzMessage, {
  EVENTS,
  handleMessage,
  initEvents,
} from "@/__main__/ipc-core.mjs";
import { setVolatileKV } from "@/app/actions.mjs";
import { GAME_SYMBOL_BY_SHORT_NAME } from "@/app/constants.mjs";
import { GAME_SYMBOL_LOL } from "@/game-lol/definition-symbol.mjs";
import { GAME_SYMBOL_TFT } from "@/game-tft/definition-symbol.mjs";
import { updateLatestPlayed } from "@/util/update-latest-played.mjs";

export { updateLatestPlayed };

const listeners = [];
let started = false;

export const getGameState = async () => {
  const result = await blitzMessage(EVENTS.GET_RUNNING_GAMES);
  const out = {};
  for (const short in result)
    out[GAME_SYMBOL_BY_SHORT_NAME[short]] = result[short];
  return out;
};
const isTft = (name) => {
  return (
    name === GAME_SYMBOL_LOL &&
    readState.volatile?.currentGameTuple?.length &&
    readState.volatile.currentGameTuple[0] === GAME_SYMBOL_TFT
  );
};
const registerHandlers = async () => {
  await initEvents;
  handleMessage(EVENTS.START_GAME, (passed) => {
    const name =
      GAME_SYMBOL_BY_SHORT_NAME[passed?.toLowerCase?.()] ||
      GAME_SYMBOL_BY_SHORT_NAME[passed];
    const result = isTft(name) ? GAME_SYMBOL_TFT : name;
    updateLatestPlayed(result);
    for (const e of listeners) e(result, true);
  });
  handleMessage(EVENTS.EXIT_GAME, (passed) => {
    const name =
      GAME_SYMBOL_BY_SHORT_NAME[passed?.toLowerCase?.()] ||
      GAME_SYMBOL_BY_SHORT_NAME[passed];
    const result = isTft(name) ? GAME_SYMBOL_TFT : name;
    for (const e of listeners) e(result, false);
  });
};
export const subscribe = (cb) => {
  listeners.push(cb);
  if (!started) {
    started = true;
    registerHandlers();
  }
  return () => {
    listeners.splice(listeners.indexOf(cb), 1);
  };
};
export function subscribeKvToGameState() {
  getGameState().then((res) => {
    setVolatileKV("runningGamesState", res);
  });
  return subscribe((symbol, newState) => {
    setVolatileKV("runningGamesState", {
      ...readState.volatile.runningGamesState,
      [symbol]: newState,
      when: Date.now(), // this is to ensure that we actually update the state
    });
  });
}
